<template>
  <router-view />
</template>

<script>
export default {
    name: "StartupUser",
    components: {},
    data() {
        return {};
    },
};
</script>

<style lang="scss">
</style>

